import { useEventListener } from '@web/composables/useEventListener';

// Run the callback whenever the browser tab becomes visible again
// (e.g. the user switches back from another tab or window).
export function useOnTabVisible(callback: () => void) {
  useEventListener(document, 'visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      callback();
    }
  });
}
